import dayjs, { Dayjs } from 'dayjs'

// 全体共通の日付フォーマット
export const getDateFormat = (dateString: string | null) =>
  dayjs(dateString).format('YYYY/MM/DD')

// RFC3339形式の日付フォーマット (APIパラメータとして利用)
export const dateToFormatRFC3339 = (date: Dayjs) =>
  date.utc().format('YYYY-MM-DDTHH:mm:ss')
